import en from './en';
import fr from './fr';

const dictionaries = { en, fr };

const resolve = (dictionary, path) => {
  return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), dictionary);
};

export const translate = (language, path, vars) => {
  const dictionary = dictionaries[language] || dictionaries.en;
  let value = resolve(dictionary, path);
  if (value === undefined) {
    value = resolve(dictionaries.en, path);
  }
  if (typeof value === 'function') {
    return value(vars || {});
  }
  return value;
};

export default dictionaries;
